import React, { Component } from 'react';
import deviceDOMHoc from '../../hocs/deviceDOMHoc';
import {
  inject,
  observer,
} from 'mobx-react';

@inject('batchStore')
@observer
class ManualPanel extends Component {
  render() {
    const { device, batchStore } = this.props;
    const active = !batchStore.isInputPortOff(device.startDischPNo) ? 'active' : '';

    return (
      <div id={`device-${device.id}`} className={`${active} device-gui device-gui--manual-panel`}>
        {device.description && (
          <div className="device-label device-icon">
            <div className="device-type" title={`#${device.id}`}>{device.description}</div>
          </div>
        )}
        <div className="device-icon body"/>
      </div>
    );
  }
}

export default deviceDOMHoc(ManualPanel);
